import React, { useCallback, useRef, useState } from "react";
import { IoMdCloseCircle } from "react-icons/io";
import "./ImageInput.scss";
import { useDispatch } from "react-redux";
import { updateOpenSubscriptionAd } from "../../redux/features/subscription-slice";
import ReactDOM from "react-dom";

import Cropper from "react-easy-crop";
import imageCompression from "browser-image-compression";

const ImageInput = ({
  image,
  setImage,
  label,
  featureAvailable,
  isAllowed,
}) => {
  const dispatch = useDispatch();

  const imageRef = useRef(null);

  const [cropSrc, setCropSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropComplete = useCallback((croppedArea, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  }, []);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    console.log(file);

    if (file) {
      const url = URL.createObjectURL(file);
      setCropSrc(url);
    } else {
      setImage({ src: null, file: null });
    }
  };

  const getCroppedImg = (imageSrc, cropPixels) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = imageSrc;
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = cropPixels.width;
        canvas.height = cropPixels.height;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(
          image,
          cropPixels.x,
          cropPixels.y,
          cropPixels.width,
          cropPixels.height,
          0,
          0,
          cropPixels.width,
          cropPixels.height
        );

        canvas.toBlob(
          (blob) => {
            if (!blob) {
              reject(new Error("Canvas empty"));
              return;
            }
            blob.name = "cropped.jpeg";
            resolve(blob);
          },
          "image/jpeg",
          1
        );
      };
    });
  };

  const handleCropSave = async () => {
    try {
      const croppedBlob = await getCroppedImg(cropSrc, croppedAreaPixels);

      const compressedFile = await imageCompression(croppedBlob, {
        maxSizeMB: 2,
        maxWidthOrHeight: 1024,
        useWebWorker: true,
      });

      setImage({
        src: URL.createObjectURL(compressedFile),
        file: compressedFile,
      });

      setCropSrc(null);
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <div
      className="custom-image-input"
      onChange={(e) => {
        if (featureAvailable) {
          handleImageChange(e);
        } else {
          dispatch(updateOpenSubscriptionAd({ openAd: true }));
        }
      }}
    >
      {isAllowed && <input ref={imageRef} type="file" accept="image/*" />}
      <img
        className="display-img"
        src={image.src || "/images/noImage.svg"}
        alt=""
        aria-label={label}
      />

      {image.src && (
        <IoMdCloseCircle
          onClick={() =>
            setImage({
              file: null,
              src: null,
            })
          }
        />
      )}

      {cropSrc &&
        ReactDOM.createPortal(
          <div className="cropper-modal">
            <div className="cropper-modal-wrapper">
              <div className="cropper-wrapper">
                <Cropper
                  image={cropSrc}
                  crop={crop}
                  zoom={zoom}
                  aspect={1}
                  onCropChange={setCrop}
                  onZoomChange={setZoom}
                  onCropComplete={onCropComplete}
                />
              </div>
              <div className="cropper-actions">
                <button
                  type="button"
                  className="primary"
                  onClick={handleCropSave}
                >
                  Save
                </button>
                <button
                  type="button"
                  className="danger"
                  onClick={() => {
                    setCropSrc(null);
                    setImage(image);
                    if (imageRef.current) {
                      imageRef.current.value = "";
                    }
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}
    </div>
  );
};

export default ImageInput;
